import React, { useState, Suspense } from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import useEffectLocation from "../hooks/useEffectLocation";

import './style.scss';

const MainDemo = React.lazy(() => import("../views/home/MainDemo"));
// const Navbar = React.lazy(() => import("../components/nav/Navbar"));
const About = React.lazy(() => import("../views/About"));
const Contact = React.lazy(() => import("../views/Contact"));
const BlogDetails = React.lazy(() => import("../views/blog/BlogDetails"));

const Products = React.lazy(() => import("../views/Products"));
const ProductDetail = React.lazy(() => import("../views/ProductDetail"));
const Catalogue = React.lazy(() => import("../views/Catalogue"));
const Exports = React.lazy(() => import("../views/Exports"));
const Country = React.lazy(() => import("../views/Country"));
const Calculator = React.lazy(() => import("../views/Calculator"));
const Packing = React.lazy(() => import("../views/Packing"));
const Technical = React.lazy(() => import("../views/Technical"));
const News = React.lazy(() => import("../views/News"));
const NotFound = React.lazy(() => import("../views/NotFound"));

const Router = () => {

    const [transPage, setTransPage] = useState("in");
    const scrollbar = useSelector(state => state.scrollbar);

    const location = useEffectLocation((l) => {
        setTransPage("out");
    })

    const onAnimateEnd = () => {
        if (transPage !== "out") return;
        scrollbar.current?.scrollTo(0, 0, 0);
        window.scrollTo({ left: 0, top: 0 });
        setTransPage("in");
    }


    return (

        <div id="dsn-content" className={`dsn-transition-page dsn-animate-${transPage}`}
            onAnimationEnd={onAnimateEnd}
        >
            <Suspense fallback={<div className="background-main h-100-v" />}>
                <Routes location={location}>

                    <Route path="/" element={<MainDemo />} />
                    {/* <Route path="/navbar" element={<Navbar />} /> */}
                    <Route exact path="/about-us" element={<About />} />
                    <Route exact path="/services" element={<About />} />
                    <Route exact path="/contact-us" element={<Contact />} />
                    <Route exact path="/product/:slug" element={<Products />} />
                    {/* <Route exact path="/products/:slug/:sslug/collections" element={<SubProducts />} /> */}
                    <Route exact path="/products/:slug/:pslug" element={<ProductDetail />} />
                    <Route exact path="/technical-specification-wall-tiles" element={<Technical />} />
                    <Route exact path="/packing-detail" element={<Packing />} />
                    <Route exact path="/tiles-calculator" element={<Calculator />} />
                    <Route exact path="/catalogue" element={<Catalogue />} />
                    <Route exact path="/exporting-countries" element={<Exports />} />
                    <Route exact path="/exports/:slug" element={<Country />} />
                    <Route exact path="/blog" element={<News />} />
                    <Route exact path="/news/:slug" element={<BlogDetails />} />
                    <Route exact path="*" element={<NotFound />} />
                    
                </Routes>
            </Suspense>
        </div>


    );
}

export default React.memo(Router);